import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { selectRoomById } from '@/redux/reducers/room.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { isStaff } from '@/utils/type-guards'

export function useEmergencyRoom(roomId?: string) {
  const authUser = useAppSelector(selectAuthUser)
  return useAppSelector((state) => {
    if (!authUser || !isStaff(authUser)) return null

    if (authUser.status === 'MEDECIN') return roomId ? selectRoomById(state, roomId) : null

    return authUser.emergencyRoom
      ? selectRoomById(state, typeof authUser.emergencyRoom === 'string' ? authUser.emergencyRoom : authUser.emergencyRoom._id)
      : null
  })
}
